<template>
  <datatable
    :url="ajaxUrl"
    :order-by="orderBy"
    :order-asc="orderAsc"
    search-placeholder="Search all users..."
  >
    <template #headings>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="name"
        @set-order-by="setOrder"
      >
        Name
      </sortableTh>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="email"
        @set-order-by="setOrder"
      >
        Email
      </sortableTh>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="created_at"
        @set-order-by="setOrder"
      >
        Created at
      </sortableTh>
      <th></th>
    </template>
    <template #rows="{ data }">
      <tr v-for="user in data" :key="user.id">
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.created_at }}</td>
        <td v-html="user.actions"></td>
      </tr>
    </template>
  </datatable>
</template>

<script setup>
import { ref } from "vue";
import datatable from "@/components/datatable.vue";
import sortableTh from "@/components/datatable/sortableTh.vue";

const props = defineProps({
  ajaxUrl: String,
});

const orderBy = ref("created_at");
const orderAsc = ref(false);

const setOrder = function (input) {
  if (orderBy.value == input) {
    orderAsc.value = !orderAsc.value;
  } else {
    orderBy.value = input;
    orderAsc.value = true;
  }
};
</script>
